import { LuArrowDown } from 'react-icons/lu'

function ScrollIndicator() {
    return (
        <a className="scroll-indicator" href="#projects">
            Onto the projects <LuArrowDown aria-hidden="true" />
        </a>
    )
}

export default ScrollIndicator
